// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Страница «Календарь». Токены на .cal-page, тёмная тема — из
   общего data-theme. Модуль самодостаточный: папка + этот файл.
   ============================================================ */

.cal-page {
  --cl-bg: #ffffff;
  --cl-bg-muted: #f7f7f8;
  --cl-bg-hover: #f1f1f3;
  --cl-border: rgba(15, 23, 42, 0.09);
  --cl-text: #09090b;
  --cl-text-muted: #71717a;
  --cl-accent: #18181b;
  --cl-accent-text: #fafafa;
  --cl-radius: 14px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0 24px;
  height: calc(100vh - var(--app-content-offset, 148px));
  min-height: 560px;
  color: var(--cl-text);
}

:root[data-theme='dark'] .cal-page {
  --cl-bg: #0a0a0a;
  --cl-bg-muted: #141416;
  --cl-bg-hover: #1e1e22;
  --cl-border: rgba(148, 163, 184, 0.16);
  --cl-text: #fafafa;
  --cl-text-muted: #a1a1aa;
  --cl-accent: #e4e4e7;
  --cl-accent-text: #09090b;
}

.cal-page-title {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.cal-page-subtitle {
  margin: 4px 0 0;
  color: var(--cl-text-muted);
  font-size: 0.9rem;
}

.cal-shell {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  flex: 1 1 auto;
  min-height: 0;
  gap: 16px;
}

/* ── Кнопки ── */
.cal-primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 14px;
  border: none;
  border-radius: 10px;
  background: var(--cl-accent);
  color: var(--cl-accent-text);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
}

.cal-primary-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.cal-secondary-btn,
.cal-today-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1px solid var(--cl-border);
  border-radius: 10px;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.cal-secondary-btn:hover,
.cal-today-btn:hover {
  background: var(--cl-bg-hover);
}

.cal-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--cl-text-muted);
  cursor: pointer;
}

.cal-icon-btn.bordered {
  border: 1px solid var(--cl-border);
  color: var(--cl-text);
}

.cal-icon-btn:hover {
  background: var(--cl-bg-hover);
  color: var(--cl-text);
}

/* ── Боковая колонка ── */
.cal-sidebar {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  min-height: 0;
  overflow-y: auto;
  border: 1px solid var(--cl-border);
  border-radius: var(--cl-radius);
  background: var(--cl-bg);
}

.cal-mini-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 8px;
}

.cal-mini-title {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: capitalize;
}

.cal-mini-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.cal-mini-weekday {
  padding: 4px 0;
  text-align: center;
  color: var(--cl-text-muted);
  font-size: 0.68rem;
  text-transform: capitalize;
}

.cal-mini-day {
  position: relative;
  aspect-ratio: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.76rem;
  cursor: pointer;
}

.cal-mini-day:hover {
  background: var(--cl-bg-hover);
}

.cal-mini-day.outside {
  color: var(--cl-text-muted);
  opacity: 0.55;
}

.cal-mini-day.selected {
  background: var(--cl-accent);
  color: var(--cl-accent-text);
  font-weight: 700;
}

.cal-mini-dot {
  position: absolute;
  bottom: 3px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.7;
}

.cal-groups {
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-top: 1px solid var(--cl-border);
  padding-top: 12px;
  flex: 1 1 auto;
}

.cal-group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 4px;
  border: none;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
}

.cal-group-list {
  list-style: none;
  margin: 0;
  padding: 0 0 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cal-calendar-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 6px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}

.cal-calendar-row:hover {
  background: var(--cl-bg-hover);
}

.cal-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border-radius: 5px;
  border: 1.5px solid var(--cl-border);
  color: #fff;
}

/* ── Основная область ── */
.cal-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  border: 1px solid var(--cl-border);
  border-radius: var(--cl-radius);
  background: var(--cl-bg);
  overflow: hidden;
}

.cal-toolbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-bottom: 1px solid var(--cl-border);
}

.cal-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.cal-period {
  margin: 0 0 0 8px;
  font-size: 1.15rem;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
}

.cal-toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cal-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--cl-border);
  border-radius: 10px;
  color: var(--cl-text-muted);
}

.cal-search input {
  width: 190px;
  border: none;
  outline: none;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.85rem;
}

.cal-view-select {
  position: relative;
}

.cal-view-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid var(--cl-border);
  border-radius: 10px;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.cal-view-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 30;
  min-width: 150px;
  padding: 6px;
  border: 1px solid var(--cl-border);
  border-radius: 12px;
  background: var(--cl-bg);
  box-shadow: 0 12px 32px -14px rgba(0, 0, 0, 0.45);
}

.cal-view-menu button {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--cl-text);
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}

.cal-view-menu button:hover,
.cal-view-menu button.active {
  background: var(--cl-bg-hover);
}

/* ── Месячная сетка ── */
.cal-month {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.cal-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: 1px solid var(--cl-border);
}

.cal-weekdays span {
  padding: 10px 8px;
  text-align: center;
  color: var(--cl-text-muted);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
}

.cal-month-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: minmax(96px, 1fr);
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.cal-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  min-width: 0;
  border-right: 1px solid var(--cl-border);
  border-bottom: 1px solid var(--cl-border);
  cursor: pointer;
}

.cal-cell:nth-child(7n) {
  border-right: none;
}

.cal-cell:hover {
  background: var(--cl-bg-muted);
}

.cal-cell.outside {
  background: var(--cl-bg-muted);
  color: var(--cl-text-muted);
}

.cal-cell.selected {
  outline: 2px solid var(--cl-accent);
  outline-offset: -2px;
}

.cal-cell-date {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  font-size: 0.8rem;
  font-weight: 600;
}

.cal-cell-date.today {
  background: var(--cl-accent);
  color: var(--cl-accent-text);
}

.cal-cell-events {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.cal-event {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  min-width: 0;
}

.cal-event-title {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cal-event-time {
  opacity: 0.85;
  font-variant-numeric: tabular-nums;
}

.cal-more {
  color: var(--cl-text-muted);
  font-size: 0.7rem;
  padding-left: 4px;
}

/* ── Неделя и день списком ── */
.cal-agenda {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.cal-agenda-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
}

.cal-agenda-date {
  font-size: 1.05rem;
  font-weight: 700;
}

.cal-agenda-head.today .cal-agenda-date {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--cl-accent);
  color: var(--cl-accent-text);
}

.cal-agenda-weekday {
  color: var(--cl-text-muted);
  font-size: 0.85rem;
  text-transform: capitalize;
}

.cal-agenda-empty {
  margin: 0;
  color: var(--cl-text-muted);
  font-size: 0.84rem;
}

.cal-agenda-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cal-agenda-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--cl-border);
  border-radius: 10px;
  background: var(--cl-bg-muted);
  color: var(--cl-text);
  text-align: left;
  cursor: pointer;
}

.cal-agenda-item:hover {
  background: var(--cl-bg-hover);
}

.cal-agenda-color {
  width: 4px;
  align-self: stretch;
  border-radius: 4px;
  flex: 0 0 4px;
}

.cal-agenda-title {
  font-weight: 600;
  font-size: 0.92rem;
}

.cal-agenda-meta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--cl-text-muted);
  font-size: 0.8rem;
}

/* ── Модалка события ── */
.cal-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
}

.cal-modal {
  width: min(520px, 100%);
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));
  border-radius: 16px;
  background: var(--bg-primary, #fff);
  color: var(--text-primary, #0f172a);
  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.5);
}

.cal-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cal-modal-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.cal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--text-secondary, #64748b);
}

.cal-field input,
.cal-field select,
.cal-field textarea {
  padding: 9px 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary, #0f172a);
  font-family: inherit;
  font-size: 0.9rem;
  outline: none;
  resize: vertical;
}

.cal-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.cal-modal-foot {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}

.cal-modal-submit {
  margin-left: auto;
}

.cal-delete-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid var(--accent-error, #dc2626);
  background: transparent;
  color: var(--accent-error, #dc2626);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

/* ── Адаптив ── */
@media (max-width: 1000px) {
  .cal-page {
    height: auto;
  }

  .cal-shell {
    grid-template-columns: 1fr;
  }

  .cal-sidebar {
    max-height: none;
  }

  .cal-month-grid {
    grid-auto-rows: minmax(80px, auto);
  }

  .cal-search input {
    width: 130px;
  }
}

/* ── Модалка события: поля, селекты, тумблеры ── */
.cal-modal-sub {
  margin: 4px 0 0;
  color: var(--text-secondary, #64748b);
  font-size: 0.82rem;
}

.cal-modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cal-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: 0 0 9px;
}

.cal-field-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary, #0f172a);
}

.cal-select {
  position: relative;
}

.cal-select.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.cal-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary, #0f172a);
  font-size: 0.9rem;
  cursor: pointer;
}

.cal-select-value {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.cal-select-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 40;
  min-width: 100%;
  max-height: 260px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.25));
  border-radius: 12px;
  background: var(--bg-primary, #fff);
  box-shadow: 0 18px 40px -18px rgba(15, 23, 42, 0.5);
}

.cal-select-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary, #0f172a);
  font-size: 0.88rem;
  text-align: left;
  cursor: pointer;
}

.cal-select-option:hover,
.cal-select-option.active {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
}

.cal-select-option-label {
  flex: 1 1;
}

.cal-date-popover {
  width: 260px;
  padding: 10px;
}

.cal-toggles {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  padding-top: 4px;
}

.cal-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  color: var(--text-primary, #0f172a);
  font-size: 0.85rem;
  white-space: nowrap;
  cursor: pointer;
}

.cal-toggle-track {
  display: inline-flex;
  align-items: center;
  width: 36px;
  height: 20px;
  padding: 2px;
  border-radius: 999px;
  background: var(--border-color, rgba(148, 163, 184, 0.4));
  transition: background 0.15s ease;
}

/* В тёмной теме белый трек сливался с белым кружком — красим акцентом */
.cal-toggle.on .cal-toggle-track {
  background: var(--accent-primary, #2563eb);
}

.cal-toggle-knob {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s ease;
}

.cal-toggle.on .cal-toggle-knob {
  transform: translateX(16px);
}

.cal-attendees-row {
  display: flex;
  gap: 8px;
}

.cal-attendees-row input {
  flex: 1 1;
  padding: 9px 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary, #0f172a);
  font-family: inherit;
  font-size: 0.9rem;
  outline: none;
}

.cal-attendee-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.cal-attendee-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  background: transparent;
  color: inherit;
  font-size: 0.78rem;
  cursor: pointer;
}

.cal-modal-foot .cal-secondary-btn {
  padding: 11px 16px;
}

/* ── Режим списка ── */
.cal-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cal-list--empty {
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--cl-text-muted);
  font-size: 0.88rem;
}

.cal-list-item {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px 18px;
  border: 1px solid var(--cl-border);
  border-radius: 14px;
  background: var(--cl-bg);
  color: var(--cl-text);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.cal-list-item:hover {
  background: var(--cl-bg-muted);
  border-color: var(--cl-text-muted);
}

.cal-list-dot {
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
}

.cal-list-main {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1 1;
}

.cal-list-title {
  font-size: 1.02rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.cal-list-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  color: var(--cl-text-muted);
  font-size: 0.84rem;
}

.cal-list-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.cal-list-attendees {
  display: inline-flex;
}

.cal-list-attendee {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin-left: -6px;
  border-radius: 50%;
  border: 2px solid var(--cl-bg);
  background: var(--cl-bg-muted);
  font-size: 0.7rem;
  font-weight: 700;
}

.cal-list-more {
  display: inline-flex;
  color: var(--cl-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/calendar/calendar.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,sDAAsD;EACtD,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;;EAGE,iBAAiB;EACjB,+DAA+D;EAC/D,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,+DAA+D;EAC/D,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gEAAgE;EAChE,mBAAmB;EACnB,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,yDAAyD;EACzD,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,+DAA+D;EAC/D,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,+DAA+D;EAC/D,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B","sourcesContent":["/* ============================================================\n   Страница «Календарь». Токены на .cal-page, тёмная тема — из\n   общего data-theme. Модуль самодостаточный: папка + этот файл.\n   ============================================================ */\n\n.cal-page {\n  --cl-bg: #ffffff;\n  --cl-bg-muted: #f7f7f8;\n  --cl-bg-hover: #f1f1f3;\n  --cl-border: rgba(15, 23, 42, 0.09);\n  --cl-text: #09090b;\n  --cl-text-muted: #71717a;\n  --cl-accent: #18181b;\n  --cl-accent-text: #fafafa;\n  --cl-radius: 14px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 8px 0 24px;\n  height: calc(100vh - var(--app-content-offset, 148px));\n  min-height: 560px;\n  color: var(--cl-text);\n}\n\n:root[data-theme='dark'] .cal-page {\n  --cl-bg: #0a0a0a;\n  --cl-bg-muted: #141416;\n  --cl-bg-hover: #1e1e22;\n  --cl-border: rgba(148, 163, 184, 0.16);\n  --cl-text: #fafafa;\n  --cl-text-muted: #a1a1aa;\n  --cl-accent: #e4e4e7;\n  --cl-accent-text: #09090b;\n}\n\n.cal-page-title {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.cal-page-subtitle {\n  margin: 4px 0 0;\n  color: var(--cl-text-muted);\n  font-size: 0.9rem;\n}\n\n.cal-shell {\n  display: grid;\n  grid-template-columns: 280px minmax(0, 1fr);\n  flex: 1 1 auto;\n  min-height: 0;\n  gap: 16px;\n}\n\n/* ── Кнопки ── */\n.cal-primary-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 14px;\n  border: none;\n  border-radius: 10px;\n  background: var(--cl-accent);\n  color: var(--cl-accent-text);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cal-primary-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.cal-secondary-btn,\n.cal-today-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 9px 14px;\n  border: 1px solid var(--cl-border);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cal-secondary-btn:hover,\n.cal-today-btn:hover {\n  background: var(--cl-bg-hover);\n}\n\n.cal-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 7px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--cl-text-muted);\n  cursor: pointer;\n}\n\n.cal-icon-btn.bordered {\n  border: 1px solid var(--cl-border);\n  color: var(--cl-text);\n}\n\n.cal-icon-btn:hover {\n  background: var(--cl-bg-hover);\n  color: var(--cl-text);\n}\n\n/* ── Боковая колонка ── */\n.cal-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 16px;\n  min-height: 0;\n  overflow-y: auto;\n  border: 1px solid var(--cl-border);\n  border-radius: var(--cl-radius);\n  background: var(--cl-bg);\n}\n\n.cal-mini-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.cal-mini-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.cal-mini-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.cal-mini-weekday {\n  padding: 4px 0;\n  text-align: center;\n  color: var(--cl-text-muted);\n  font-size: 0.68rem;\n  text-transform: capitalize;\n}\n\n.cal-mini-day {\n  position: relative;\n  aspect-ratio: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.76rem;\n  cursor: pointer;\n}\n\n.cal-mini-day:hover {\n  background: var(--cl-bg-hover);\n}\n\n.cal-mini-day.outside {\n  color: var(--cl-text-muted);\n  opacity: 0.55;\n}\n\n.cal-mini-day.selected {\n  background: var(--cl-accent);\n  color: var(--cl-accent-text);\n  font-weight: 700;\n}\n\n.cal-mini-dot {\n  position: absolute;\n  bottom: 3px;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.7;\n}\n\n.cal-groups {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  border-top: 1px solid var(--cl-border);\n  padding-top: 12px;\n  flex: 1 1 auto;\n}\n\n.cal-group-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 8px 4px;\n  border: none;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cal-group-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cal-calendar-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 7px 6px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cal-calendar-row:hover {\n  background: var(--cl-bg-hover);\n}\n\n.cal-checkbox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  border-radius: 5px;\n  border: 1.5px solid var(--cl-border);\n  color: #fff;\n}\n\n/* ── Основная область ── */\n.cal-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  border: 1px solid var(--cl-border);\n  border-radius: var(--cl-radius);\n  background: var(--cl-bg);\n  overflow: hidden;\n}\n\n.cal-toolbar {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--cl-border);\n}\n\n.cal-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.cal-period {\n  margin: 0 0 0 8px;\n  font-size: 1.15rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n\n.cal-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cal-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--cl-border);\n  border-radius: 10px;\n  color: var(--cl-text-muted);\n}\n\n.cal-search input {\n  width: 190px;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.85rem;\n}\n\n.cal-view-select {\n  position: relative;\n}\n\n.cal-view-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 12px;\n  border: 1px solid var(--cl-border);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cal-view-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 30;\n  min-width: 150px;\n  padding: 6px;\n  border: 1px solid var(--cl-border);\n  border-radius: 12px;\n  background: var(--cl-bg);\n  box-shadow: 0 12px 32px -14px rgba(0, 0, 0, 0.45);\n}\n\n.cal-view-menu button {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--cl-text);\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cal-view-menu button:hover,\n.cal-view-menu button.active {\n  background: var(--cl-bg-hover);\n}\n\n/* ── Месячная сетка ── */\n.cal-month {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.cal-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  border-bottom: 1px solid var(--cl-border);\n}\n\n.cal-weekdays span {\n  padding: 10px 8px;\n  text-align: center;\n  color: var(--cl-text-muted);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.cal-month-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-auto-rows: minmax(96px, 1fr);\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.cal-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 6px;\n  min-width: 0;\n  border-right: 1px solid var(--cl-border);\n  border-bottom: 1px solid var(--cl-border);\n  cursor: pointer;\n}\n\n.cal-cell:nth-child(7n) {\n  border-right: none;\n}\n\n.cal-cell:hover {\n  background: var(--cl-bg-muted);\n}\n\n.cal-cell.outside {\n  background: var(--cl-bg-muted);\n  color: var(--cl-text-muted);\n}\n\n.cal-cell.selected {\n  outline: 2px solid var(--cl-accent);\n  outline-offset: -2px;\n}\n\n.cal-cell-date {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.cal-cell-date.today {\n  background: var(--cl-accent);\n  color: var(--cl-accent-text);\n}\n\n.cal-cell-events {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.cal-event {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 6px;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  min-width: 0;\n}\n\n.cal-event-title {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cal-event-time {\n  opacity: 0.85;\n  font-variant-numeric: tabular-nums;\n}\n\n.cal-more {\n  color: var(--cl-text-muted);\n  font-size: 0.7rem;\n  padding-left: 4px;\n}\n\n/* ── Неделя и день списком ── */\n.cal-agenda {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.cal-agenda-head {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.cal-agenda-date {\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.cal-agenda-head.today .cal-agenda-date {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--cl-accent);\n  color: var(--cl-accent-text);\n}\n\n.cal-agenda-weekday {\n  color: var(--cl-text-muted);\n  font-size: 0.85rem;\n  text-transform: capitalize;\n}\n\n.cal-agenda-empty {\n  margin: 0;\n  color: var(--cl-text-muted);\n  font-size: 0.84rem;\n}\n\n.cal-agenda-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cal-agenda-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--cl-border);\n  border-radius: 10px;\n  background: var(--cl-bg-muted);\n  color: var(--cl-text);\n  text-align: left;\n  cursor: pointer;\n}\n\n.cal-agenda-item:hover {\n  background: var(--cl-bg-hover);\n}\n\n.cal-agenda-color {\n  width: 4px;\n  align-self: stretch;\n  border-radius: 4px;\n  flex: 0 0 4px;\n}\n\n.cal-agenda-title {\n  font-weight: 600;\n  font-size: 0.92rem;\n}\n\n.cal-agenda-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--cl-text-muted);\n  font-size: 0.8rem;\n}\n\n/* ── Модалка события ── */\n.cal-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.cal-modal {\n  width: min(520px, 100%);\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));\n  border-radius: 16px;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary, #0f172a);\n  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.5);\n}\n\n.cal-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cal-modal-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.cal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--text-secondary, #64748b);\n}\n\n.cal-field input,\n.cal-field select,\n.cal-field textarea {\n  padding: 9px 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary, #0f172a);\n  font-family: inherit;\n  font-size: 0.9rem;\n  outline: none;\n  resize: vertical;\n}\n\n.cal-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.cal-modal-foot {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.cal-modal-submit {\n  margin-left: auto;\n}\n\n.cal-delete-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--accent-error, #dc2626);\n  background: transparent;\n  color: var(--accent-error, #dc2626);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* ── Адаптив ── */\n@media (max-width: 1000px) {\n  .cal-page {\n    height: auto;\n  }\n\n  .cal-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .cal-sidebar {\n    max-height: none;\n  }\n\n  .cal-month-grid {\n    grid-auto-rows: minmax(80px, auto);\n  }\n\n  .cal-search input {\n    width: 130px;\n  }\n}\n\n/* ── Модалка события: поля, селекты, тумблеры ── */\n.cal-modal-sub {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.82rem;\n}\n\n.cal-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cal-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex: 0 0 9px;\n}\n\n.cal-field-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary, #0f172a);\n}\n\n.cal-select {\n  position: relative;\n}\n\n.cal-select.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.cal-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 9px 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary, #0f172a);\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.cal-select-value {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cal-select-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 40;\n  min-width: 100%;\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 6px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.25));\n  border-radius: 12px;\n  background: var(--bg-primary, #fff);\n  box-shadow: 0 18px 40px -18px rgba(15, 23, 42, 0.5);\n}\n\n.cal-select-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary, #0f172a);\n  font-size: 0.88rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cal-select-option:hover,\n.cal-select-option.active {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n}\n\n.cal-select-option-label {\n  flex: 1;\n}\n\n.cal-date-popover {\n  width: 260px;\n  padding: 10px;\n}\n\n.cal-toggles {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  padding-top: 4px;\n}\n\n.cal-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  background: transparent;\n  color: var(--text-primary, #0f172a);\n  font-size: 0.85rem;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.cal-toggle-track {\n  display: inline-flex;\n  align-items: center;\n  width: 36px;\n  height: 20px;\n  padding: 2px;\n  border-radius: 999px;\n  background: var(--border-color, rgba(148, 163, 184, 0.4));\n  transition: background 0.15s ease;\n}\n\n/* В тёмной теме белый трек сливался с белым кружком — красим акцентом */\n.cal-toggle.on .cal-toggle-track {\n  background: var(--accent-primary, #2563eb);\n}\n\n.cal-toggle-knob {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  transition: transform 0.15s ease;\n}\n\n.cal-toggle.on .cal-toggle-knob {\n  transform: translateX(16px);\n}\n\n.cal-attendees-row {\n  display: flex;\n  gap: 8px;\n}\n\n.cal-attendees-row input {\n  flex: 1;\n  padding: 9px 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary, #0f172a);\n  font-family: inherit;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.cal-attendee-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.cal-attendee-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  background: transparent;\n  color: inherit;\n  font-size: 0.78rem;\n  cursor: pointer;\n}\n\n.cal-modal-foot .cal-secondary-btn {\n  padding: 11px 16px;\n}\n\n/* ── Режим списка ── */\n.cal-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cal-list--empty {\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: var(--cl-text-muted);\n  font-size: 0.88rem;\n}\n\n.cal-list-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  padding: 16px 18px;\n  border: 1px solid var(--cl-border);\n  border-radius: 14px;\n  background: var(--cl-bg);\n  color: var(--cl-text);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.cal-list-item:hover {\n  background: var(--cl-bg-muted);\n  border-color: var(--cl-text-muted);\n}\n\n.cal-list-dot {\n  width: 10px;\n  height: 10px;\n  flex: 0 0 10px;\n}\n\n.cal-list-main {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  flex: 1;\n}\n\n.cal-list-title {\n  font-size: 1.02rem;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.cal-list-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  color: var(--cl-text-muted);\n  font-size: 0.84rem;\n}\n\n.cal-list-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.cal-list-attendees {\n  display: inline-flex;\n}\n\n.cal-list-attendee {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  margin-left: -6px;\n  border-radius: 50%;\n  border: 2px solid var(--cl-bg);\n  background: var(--cl-bg-muted);\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.cal-list-more {\n  display: inline-flex;\n  color: var(--cl-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
